import {
  createCustomAttributes,
  type CustomAttributes,
  type LoginMode,
} from './utils';
import {
  isBookmarks,
  isBookmarksSortPreference,
  isCmsBookmarks,
  isCmsEditorHistory,
  isContentPromoterPreference,
  isInfoPanelPreference,
  isInitialContentSubset,
  isInitialProductLine,
  isInitialPublishingSite,
  isMultiverseStorage,
  isPersistedExperience,
  isPersonalSettingsStorage,
  isRecentlyViewed,
  isRegionPreference,
  isSavedItems,
  isStudioQueryStorage,
  isTablePreference,
  isTableStorage,
  isTimeZonePreference,
} from './validators';

export * from './types';

export { type CustomAttributes, type LoginMode };

const customAttributesApi = {
  experience: createCustomAttributes(
    'studio.experience',
    isPersistedExperience,
  ),

  timeZonePreference: createCustomAttributes(
    'sonic.studio.time-zone-preference',
    isTimeZonePreference,
    { type: 'realm' },
  ),

  regionPreference: createCustomAttributes(
    'sonic.studio.region-preference',
    isRegionPreference,
    { region: 'en-international' },
  ),

  tablePreference: createCustomAttributes(
    'sonic.studio.table-preference',
    isTablePreference,
    { rowsPerPage: 30 },
  ),

  infoPanelPreference: createCustomAttributes(
    'sonic.studio.infopanel-preference',
    isInfoPanelPreference,
    { collapsed: false },
  ),

  contentPromoterPreference: createCustomAttributes(
    'sonic.studio.campaigns-curations',
    isContentPromoterPreference,
  ),

  recentlyViewed: createCustomAttributes(
    'sonic.studio.recently-viewed',
    isRecentlyViewed,
    { entries: [] },
  ),

  savedItems: createCustomAttributes('sonic.studio.saved-items', isSavedItems, {
    savedItems: [],
  }),

  cmsBookmarks: createCustomAttributes(
    'sonic.cms-ui.bookmarks',
    isCmsBookmarks,
    { version: 2, bookmarks: [] },
  ),

  bookmarks: createCustomAttributes('sonic.studio.bookmarks', isBookmarks, {
    version: 1,
    bookmarks: [],
  }),

  bookmarksSortPreference: createCustomAttributes(
    'sonic.studio.bookmarks.sort',
    isBookmarksSortPreference,
    { sortBy: 'application' },
  ),

  cmsEditorHistory: createCustomAttributes(
    'sonic.cms-ui.editor-history',
    isCmsEditorHistory,
    { version: 1, recentlyOpened: [] },
  ),

  initialPublishingSite: createCustomAttributes(
    'sonic.cms-ui.initial-publishing-site',
    isInitialPublishingSite,
  ),

  initialProductLine: createCustomAttributes(
    'sonic.cms-ui.initial-product-line',
    isInitialProductLine,
  ),

  initialContentSubset: createCustomAttributes(
    'sonic.vms-ui.initial-content-subset',
    isInitialContentSubset,
  ),

  multiverseStorage: createCustomAttributes(
    'sonic.studio.multiverse',
    isMultiverseStorage,
    { allowList: [], autoEnroll: [], releaseEnroll: [] },
  ),

  tableStorage: createCustomAttributes('sonic.studio.tables', isTableStorage),

  queryStorage: createCustomAttributes(
    'sonic.studio.studioQueries',
    isStudioQueryStorage,
  ),

  personalSettingsStorage: createCustomAttributes(
    'studio.personal-settings',
    isPersonalSettingsStorage,
    { backgroundVideoToggle: false },
  ),
};

export default customAttributesApi;
